import type { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { useState } from 'react'

import {
  getCorrectTaxNumberFieldName,
  personalBillingDataFieldsByCountry,
  personalDataFieldsByCountry,
} from '../../../templateComponents/Checkout/personalDataByCountry'

type Props = {
  tFormField: TranslateProps['t']
  countries?: ImmutableList
  address: Core.Address
  scopeName: 'billingAddress' | 'shippingAddress'
} & TranslateProps

const nameFields = ['firstName', 'lastName']

export default function CustomerAddressFields({
  countries: allCountries,
  scopeName,
  address,
  tFormField,
  t,
}: Readonly<Props>): ReactElement {
  const [country, setCountry] = useState(address.country || '')
  const countries = allCountries?.toJS() || []
  if (!country) countries.unshift({ value: '', label: t('countryInputField.placeholder') })

  const taxCountry = useSelector<State, string>((state: State) => state.getIn(['tax', 'country']))

  const byFieldsToShow = country
    ? (field) => !field.hide // all fields for that country
    : ({ name }) => nameFields.includes(name) // only first and last name

  const fields =
    scopeName === 'billingAddress'
      ? personalBillingDataFieldsByCountry(country, taxCountry).filter(byFieldsToShow)
      : personalDataFieldsByCountry(country).filter(byFieldsToShow)

  return (
    <>
      {fields.map((field, index) => (
        <label key={field.name}>
          {tFormField(getCorrectTaxNumberFieldName(field.name, taxCountry, country))}
          {field.required && '*'}
          <input
            defaultValue={address[field.name] || ''}
            name={field.name}
            required={field.required}
            type="text"
            // try to focus first field after name fields after selecting country
            autoFocus={index === 2}
          />
        </label>
      ))}

      <label>
        {tFormField('country')}*
        <div className="dropdown">
          <select
            name={`country`}
            value={country}
            required
            onChange={(e) => {
              setCountry(e.target.value)
            }}
          >
            {countries.map(({ value, label }) => (
              <option value={value} key={label}>
                {label}
              </option>
            ))}
          </select>
        </div>
      </label>
    </>
  )
}
